/**
 * Compara dos objetos
 * @param obj1 Primer objeto a comparar
 * @param obj2 Segundo objeto a comparar
 * @returns Boolean indicando si son iguales o no
 */
export function compareObjects(obj1: any, obj2: any, excludedKeys: string[] = []): boolean {
    // Handle null/undefined cases
    if (obj1 === obj2) {
        return true;
    }
    
    // Check if either is null/undefined
    if (!obj1 || !obj2) {
        return false;
    }
    
    // Handle arrays
    if (Array.isArray(obj1) && Array.isArray(obj2)) {
        return obj1.length === obj2.length &&
            obj1.every((item, index) => compareObjects(item, obj2[index], excludedKeys));
    }
    
    // Check if both are objects
    if (typeof obj1 !== 'object' || typeof obj2 !== 'object') {
        return false;
    }
  
    const keys1 = Object.keys(obj1).filter(key => !excludedKeys.includes(key));
    const keys2 = Object.keys(obj2).filter(key => !excludedKeys.includes(key));
  
    if (keys1.length !== keys2.length) {
      return false;
    }
  
    return keys1.every(key => {
        if (!obj2.hasOwnProperty(key)) {
            return false;
        }
        const val1 = obj1[key];
        const val2 = obj2[key];
        
        if (val1 === null || val2 === null) {
            return val1 === val2;
        }
        
        if (typeof val1 === 'object') {
            return compareObjects(val1, val2, excludedKeys);
        }
        return val1 === val2;
    });
}